var _linearGradient, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    x2: 512,
    y1: 256,
    y2: 256
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00f2fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0208,
    stopColor: "#03effe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2931,
    stopColor: "#24d2fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5538,
    stopColor: "#3cbdfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7956,
    stopColor: "#4ab0fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4facfe"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m418.144531 121.140625-82.859375 82.859375h56.714844c11.046875 0 20 8.953125 20 20s-8.953125 20-20 20h-75c-27.570312 0-50-22.429688-50-50v-75c0-11.046875 8.953125-20 20-20s20 8.953125 20 20v56.714844l82.855469-82.855469c7.8125-7.8125 20.476562-7.8125 28.285156 0 7.8125 7.808594 7.8125 20.472656.003906 28.28125zm-192.144531 288.859375c11.046875 0 20-8.953125 20-20v-75c0-27.570312-22.429688-50-50-50h-75c-11.046875 0-20 8.953125-20 20s8.953125 20 20 20h56.714844l-82.859375 82.859375c-7.808594 7.808594-7.808594 20.472656 0 28.28125 3.90625 3.90625 9.027343 5.859375 14.144531 5.859375s10.238281-1.953125 14.144531-5.859375l82.855469-82.855469v56.714844c0 11.046875 8.953125 20 20 20zm266-58c11.046875 0 20-8.953125 20-20v-252c0-44.113281-35.886719-80-80-80h-352c-44.113281 0-80 35.886719-80 80v352c0 44.113281 35.886719 80 80 80h352c44.113281 0 80-35.886719 80-80 0-11.046875-8.953125-20-20-20s-20 8.953125-20 20c0 22.054688-17.945312 40-40 40h-352c-22.054688 0-40-17.945312-40-40v-352c0-22.054688 17.945312-40 40-40h352c22.054688 0 40 17.945312 40 40v252c0 11.046875 8.953125 20 20 20zm0 0",
    fill: "url(#linear0)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg3);
export default __webpack_public_path__ + "static/media/img3.d2c4d34a0f8280e25045a9dec1ba7565.svg";
export { ForwardRef as ReactComponent };